(function () {
  function setup(form) {
    // Headings come translated from snippets/search-popular.liquid.
    var defaultState = form.querySelector('[data-predictive-search-default]');
    var PRODUCTS_LABEL = (defaultState && defaultState.dataset.labelProducts) || 'Popular products';
    var RESULTS_LABEL = (defaultState && defaultState.dataset.labelResults) || 'Results';
    var input = form.querySelector('.search__input');
    var productsSection = form.querySelector('[data-search-products-section]');
    var productsHeading = form.querySelector('[data-search-products-heading]');
    var productsRow = form.querySelector('[data-search-products-row]');
    // Marker-based, not just the bare class -- a leftover dynamically-
    // created results bar (see ensureResultsBar()) shares the same class
    // and can sit EARLIER in the DOM after a search, which would make a
    // plain class query pick up the wrong bar as "the original" here.
    var productsBar = productsSection ? productsSection.querySelector('[data-search-popular-original-bar]') : null;
    var predictiveSearchPanel = form.querySelector('.predictive-search[data-predictive-search]');
    if (!input || !productsSection || !productsHeading || !productsRow || !predictiveSearchPanel) return;

    var resultsList = null;
    var resultsBar = null;

    function ensureResultsBar() {
      if (resultsBar) return resultsBar;
      // A previous setup() closure (see showPopular()'s comment on why a
      // fresh closure runs on every reopen) may have already created one
      // of these and left it in the DOM -- reuse it via this marker
      // instead of creating a second, orphaned bar underneath the results
      // list every reopen (productsBar, the ORIGINAL popular-products bar
      // from the liquid template, never carries this marker, so it's never
      // mistaken for a leftover results bar here).
      var existing = productsSection.querySelector('[data-search-unified-results-bar]');
      if (existing) {
        resultsBar = existing;
        return resultsBar;
      }
      resultsBar = document.createElement('div');
      resultsBar.className = 'predictive-search__popular-products-bar';
      resultsBar.setAttribute('data-scroll-progress-track', '');
      resultsBar.setAttribute('data-search-unified-results-bar', '');
      var fill = document.createElement('div');
      fill.className = 'predictive-search__popular-products-bar-fill';
      fill.setAttribute('data-scroll-progress-fill', '');
      resultsBar.appendChild(fill);
      return resultsBar;
    }

    function showResults(list) {
      // Dawn's predictive-search.js replaces #predictive-search-results'
      // innerHTML on every keystroke, which creates a brand new <ul
      // id="predictive-search-results-list"> each time rather than
      // reusing the old one. Since we've relocated that element out of
      // its original spot, the old copy is never cleaned up on its own --
      // without removing it here, each keystroke stacked another row.
      productsSection.querySelectorAll('#predictive-search-results-list').forEach(function (old) {
        if (old !== list) old.remove();
      });
      // The "search for '...'" fallback entry doesn't belong in a product
      // image carousel.
      list.querySelectorAll('.predictive-search__item--term').forEach(function (el) {
        var li = el.closest('li');
        (li || el).remove();
      });

      // Collection shortcuts ("Hanorace bărbați →") rendered with the
      // results: keep only the newest block, placed right above the tiles.
      var shortcuts = predictiveSearchPanel.querySelector('[data-search-shortcuts]');
      productsSection.querySelectorAll('[data-search-shortcuts]').forEach(function (old) {
        if (old !== shortcuts) old.remove();
      });

      resultsList = list;
      productsHeading.textContent = RESULTS_LABEL;
      productsRow.style.display = 'none';
      if (productsBar) productsBar.style.display = 'none';

      var bar = ensureResultsBar();
      if (resultsList.parentElement !== productsSection) {
        productsSection.insertBefore(resultsList, productsBar);
      }
      if (bar.previousElementSibling !== resultsList || bar.parentElement !== productsSection) {
        resultsList.insertAdjacentElement('afterend', bar);
      }
      if (shortcuts) {
        productsSection.insertBefore(shortcuts, resultsList);
        shortcuts.style.display = '';
      }
      resultsList.style.display = '';
      bar.style.display = '';
      // Re-arm this progress bar's own scan guard so wishlist.js's global
      // scanner (which only initializes each bar once) picks it up again
      // if this is a reused node from an earlier search.
      delete bar.dataset.scrollProgressReady;

      predictiveSearchPanel.classList.add('predictive-search--unified-hidden');
    }

    function showPopular() {
      productsHeading.textContent = PRODUCTS_LABEL;
      productsRow.style.display = '';
      if (productsBar) productsBar.style.display = '';
      // component-predictive-search.css sets #predictive-search-results-list
      // { display: flex !important; } -- a bare el.style.display = 'none'
      // LOSES to that !important rule (inline styles only win over
      // stylesheet rules when neither or both carry !important; a
      // non-important inline style is always outranked by an !important
      // stylesheet rule regardless of specificity). Must set our own
      // override with the same !important priority to actually hide it.
      if (resultsList) resultsList.style.setProperty('display', 'none', 'important');
      if (resultsBar) resultsBar.style.display = 'none';
      // setup(form) re-runs on every details "toggle" open (see the
      // document-level listener below), each time creating a FRESH closure
      // with its own resultsList/resultsBar starting at null -- the
      // dataset-bound guard only stops event listeners from being
      // re-attached, it doesn't stop this new, empty-memory closure's own
      // showPopular() from running once via the unconditional checkResults()
      // call at the end of setup(). That fresh closure's resultsList/
      // resultsBar being null meant the two lines above were no-ops, so a
      // leftover results row from a PREVIOUS closure (still `display:''`
      // in the DOM) never actually got hidden -- it just sat there,
      // visible, right alongside the popular-products row now also shown.
      // Query live instead of trusting closure memory, so this cleanup
      // works correctly no matter which closure invocation runs it.
      productsSection.querySelectorAll('#predictive-search-results-list').forEach(function (el) {
        el.style.setProperty('display', 'none', 'important');
      });
      productsSection.querySelectorAll('[data-search-unified-results-bar], [data-search-shortcuts]').forEach(function (el) {
        el.style.display = 'none';
      });
      predictiveSearchPanel.classList.remove('predictive-search--unified-hidden');
    }

    function checkResults() {
      var list = predictiveSearchPanel.querySelector('#predictive-search-results-list');
      if (input.value.trim() === '') {
        showPopular();
        return;
      }
      if (list && list.children.length) {
        showResults(list);
      }
    }

    if (!productsSection.dataset.searchUnifiedBound) {
      productsSection.dataset.searchUnifiedBound = 'true';
      input.addEventListener('input', checkResults);
      var observer = new MutationObserver(checkResults);
      observer.observe(predictiveSearchPanel, { childList: true, subtree: true });
    }

    checkResults();
  }

  function setupAll() {
    document.querySelectorAll('form.search').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupAll);
  } else {
    setupAll();
  }

  // Re-sync each time a search <details> opens -- e.g. after being closed
  // and reopened with leftover text still in the input, where no new
  // input/mutation event would otherwise fire to restore the results view.
  document.addEventListener('toggle', function (e) {
    if (e.target.matches('details') && e.target.open) {
      setupAll();
    }
  }, true);
})();
